/**
 * Encore Foundation - 2.23.0
 *
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Global Design Systems
 * encore.spotify.net
 */

/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
var spotifyBrandSet = (exports.spotifyBrandSet = {
  background: {
    /**
     * The default background color of the spotifyBrand set.
     */
    base: '#283ea3',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#253a98',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#0c1331',
    elevated: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrand set.
     */
    base: '#1ed760',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#1ed760',

    /**
     * Fallback color
     */
    negative: '#1ed760',

    /**
     * Fallback color
     */
    warning: '#1ed760',

    /**
     * Fallback color
     */
    positive: '#1ed760',

    /**
     * Fallback color
     */
    announcement: '#1ed760',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrand set.
     */
    base: '#1ed760',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#1ed760',

    /**
     * Fallback color
     */
    negative: '#1ed760',

    /**
     * Fallback color
     */
    warning: '#1ed760',

    /**
     * Fallback color
     */
    positive: '#1ed760',

    /**
     * Fallback color
     */
    announcement: '#1ed760',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrand set.
     */
    base: '#1ed760',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#324dcb',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spotifyBrandAlternateSet = (exports.spotifyBrandAlternateSet = {
  background: {
    /**
     * The default background color of the spotifyBrandAlternate set.
     */
    base: '#1ed760',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#1fdf64',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#169c46',
    elevated: {
      /**
       * Fallback color
       */
      base: '#1ed760',

      /**
       * Fallback color
       */
      highlight: '#1ed760',

      /**
       * Fallback color
       */
      press: '#1ed760',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#1ed760',

      /**
       * Fallback color
       */
      highlight: '#1ed760',

      /**
       * Fallback color
       */
      press: '#1ed760',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#1ed760',

      /**
       * Fallback color
       */
      highlight: '#1ed760',

      /**
       * Fallback color
       */
      press: '#1ed760',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrandAlternate set.
     */
    base: '#283ea3',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#283ea3',

    /**
     * Fallback color
     */
    negative: '#283ea3',

    /**
     * Fallback color
     */
    warning: '#283ea3',

    /**
     * Fallback color
     */
    positive: '#283ea3',

    /**
     * Fallback color
     */
    announcement: '#283ea3',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrandAlternate set.
     */
    base: '#283ea3',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#283ea3',

    /**
     * Fallback color
     */
    negative: '#283ea3',

    /**
     * Fallback color
     */
    warning: '#283ea3',

    /**
     * Fallback color
     */
    positive: '#283ea3',

    /**
     * Fallback color
     */
    announcement: '#283ea3',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrandAlternate set.
     */
    base: '#283ea3',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#1abc54',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spotifyBrand2Set = (exports.spotifyBrand2Set = {
  background: {
    /**
     * The default background color of the spotifyBrand2 set.
     */
    base: '#c5f0c9',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#d9f5db',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#32c340',
    elevated: {
      /**
       * Fallback color
       */
      base: '#c5f0c9',

      /**
       * Fallback color
       */
      highlight: '#c5f0c9',

      /**
       * Fallback color
       */
      press: '#c5f0c9',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#c5f0c9',

      /**
       * Fallback color
       */
      highlight: '#c5f0c9',

      /**
       * Fallback color
       */
      press: '#c5f0c9',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#c5f0c9',

      /**
       * Fallback color
       */
      highlight: '#c5f0c9',

      /**
       * Fallback color
       */
      press: '#c5f0c9',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrand2 set.
     */
    base: '#cd1400',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#cd1400',

    /**
     * Fallback color
     */
    negative: '#cd1400',

    /**
     * Fallback color
     */
    warning: '#cd1400',

    /**
     * Fallback color
     */
    positive: '#cd1400',

    /**
     * Fallback color
     */
    announcement: '#cd1400',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrand2 set.
     */
    base: '#cd1400',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#cd1400',

    /**
     * Fallback color
     */
    negative: '#cd1400',

    /**
     * Fallback color
     */
    warning: '#cd1400',

    /**
     * Fallback color
     */
    positive: '#cd1400',

    /**
     * Fallback color
     */
    announcement: '#cd1400',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrand2 set.
     */
    base: '#cd1400',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#a3e7a9',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spotifyBrand2AlternateSet = (exports.spotifyBrand2AlternateSet = {
  background: {
    /**
     * The default background color of the spotifyBrand2Alternate set.
     */
    base: '#cd1400',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#c31300',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#780c00',
    elevated: {
      /**
       * Fallback color
       */
      base: '#cd1400',

      /**
       * Fallback color
       */
      highlight: '#cd1400',

      /**
       * Fallback color
       */
      press: '#cd1400',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#cd1400',

      /**
       * Fallback color
       */
      highlight: '#cd1400',

      /**
       * Fallback color
       */
      press: '#cd1400',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#cd1400',

      /**
       * Fallback color
       */
      highlight: '#cd1400',

      /**
       * Fallback color
       */
      press: '#cd1400',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrand2Alternate set.
     */
    base: '#c5f0c9',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#c5f0c9',

    /**
     * Fallback color
     */
    negative: '#c5f0c9',

    /**
     * Fallback color
     */
    warning: '#c5f0c9',

    /**
     * Fallback color
     */
    positive: '#c5f0c9',

    /**
     * Fallback color
     */
    announcement: '#c5f0c9',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrand2Alternate set.
     */
    base: '#c5f0c9',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#c5f0c9',

    /**
     * Fallback color
     */
    negative: '#c5f0c9',

    /**
     * Fallback color
     */
    warning: '#c5f0c9',

    /**
     * Fallback color
     */
    positive: '#c5f0c9',

    /**
     * Fallback color
     */
    announcement: '#c5f0c9',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrand2Alternate set.
     */
    base: '#c5f0c9',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#ee1700',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spotifyBrand3Set = (exports.spotifyBrand3Set = {
  background: {
    /**
     * The default background color of the spotifyBrand3 set.
     */
    base: '#fce54f',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#fdee8e',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#c1a803',
    elevated: {
      /**
       * Fallback color
       */
      base: '#fce54f',

      /**
       * Fallback color
       */
      highlight: '#fce54f',

      /**
       * Fallback color
       */
      press: '#fce54f',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#fce54f',

      /**
       * Fallback color
       */
      highlight: '#fce54f',

      /**
       * Fallback color
       */
      press: '#fce54f',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#fce54f',

      /**
       * Fallback color
       */
      highlight: '#fce54f',

      /**
       * Fallback color
       */
      press: '#fce54f',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrand3 set.
     */
    base: '#b02897',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#b02897',

    /**
     * Fallback color
     */
    negative: '#b02897',

    /**
     * Fallback color
     */
    warning: '#b02897',

    /**
     * Fallback color
     */
    positive: '#b02897',

    /**
     * Fallback color
     */
    announcement: '#b02897',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrand3 set.
     */
    base: '#b02897',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#000000',

    /**
     * Fallback color
     */
    subdued: '#b02897',

    /**
     * Fallback color
     */
    negative: '#b02897',

    /**
     * Fallback color
     */
    warning: '#b02897',

    /**
     * Fallback color
     */
    positive: '#b02897',

    /**
     * Fallback color
     */
    announcement: '#b02897',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrand3 set.
     */
    base: '#b02897',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#e6c804',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spotifyBrand3AlternateSet = (exports.spotifyBrand3AlternateSet = {
  background: {
    /**
     * The default background color of the spotifyBrand3Alternate set.
     */
    base: '#b02897',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#a7268f',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#641756',
    elevated: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
  },
  text: {
    /**
     * The default text color of the spotifyBrand3Alternate set.
     */
    base: '#fce54f',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#fce54f',

    /**
     * Fallback color
     */
    negative: '#fce54f',

    /**
     * Fallback color
     */
    warning: '#fce54f',

    /**
     * Fallback color
     */
    positive: '#fce54f',

    /**
     * Fallback color
     */
    announcement: '#fce54f',
  },
  essential: {
    /**
     * The default essential color of the spotifyBrand3Alternate set.
     */
    base: '#fce54f',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#fce54f',

    /**
     * Fallback color
     */
    negative: '#fce54f',

    /**
     * Fallback color
     */
    warning: '#fce54f',

    /**
     * Fallback color
     */
    positive: '#fce54f',

    /**
     * Fallback color
     */
    announcement: '#fce54f',
  },
  decorative: {
    /**
     * The default decorative color of the spotifyBrand3Alternate set.
     */
    base: '#fce54f',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#cd2fb0',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumSet = (exports.premiumSet = {
  background: {
    /**
     * The default background color of the premium set.
     */
    base: '#ffd2d7',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#ffdde1',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#ff7988',
    elevated: {
      /**
       * Fallback color
       */
      base: '#ffd2d7',

      /**
       * Fallback color
       */
      highlight: '#ffd2d7',

      /**
       * Fallback color
       */
      press: '#ffd2d7',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#ffd2d7',

      /**
       * Fallback color
       */
      highlight: '#ffd2d7',

      /**
       * Fallback color
       */
      press: '#ffd2d7',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#ffd2d7',

      /**
       * Fallback color
       */
      highlight: '#ffd2d7',

      /**
       * Fallback color
       */
      press: '#ffd2d7',
    },
  },
  text: {
    /**
     * The default text color of the premium set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  essential: {
    /**
     * The default essential color of the premium set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  decorative: {
    /**
     * The default decorative color of the premium set.
     */
    base: '#121212',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#ffb9c1',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumAlternateSet = (exports.premiumAlternateSet = {
  background: {
    /**
     * The default background color of the premiumAlternate set.
     */
    base: '#121212',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#1a1a1a',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#474747',
    elevated: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
  },
  text: {
    /**
     * The default text color of the premiumAlternate set.
     */
    base: '#ffd2d7',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffd2d7',

    /**
     * Fallback color
     */
    negative: '#ffd2d7',

    /**
     * Fallback color
     */
    warning: '#ffd2d7',

    /**
     * Fallback color
     */
    positive: '#ffd2d7',

    /**
     * Fallback color
     */
    announcement: '#ffd2d7',
  },
  essential: {
    /**
     * The default essential color of the premiumAlternate set.
     */
    base: '#ffd2d7',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffd2d7',

    /**
     * Fallback color
     */
    negative: '#ffd2d7',

    /**
     * Fallback color
     */
    warning: '#ffd2d7',

    /**
     * Fallback color
     */
    positive: '#ffd2d7',

    /**
     * Fallback color
     */
    announcement: '#ffd2d7',
  },
  decorative: {
    /**
     * The default decorative color of the premiumAlternate set.
     */
    base: '#ffd2d7',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#292929',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumDuoSet = (exports.premiumDuoSet = {
  background: {
    /**
     * The default background color of the premiumDuo set.
     */
    base: '#283ea3',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#253a98',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#0c1331',
    elevated: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
  },
  text: {
    /**
     * The default text color of the premiumDuo set.
     */
    base: '#ffffff',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffc862',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the premiumDuo set.
     */
    base: '#ffffff',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffc862',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the premiumDuo set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#324dcb',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumDuoAlternateSet = (exports.premiumDuoAlternateSet = {
  background: {
    /**
     * The default background color of the premiumDuoAlternate set.
     */
    base: '#ffc862',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#ffd280',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#d48900',
    elevated: {
      /**
       * Fallback color
       */
      base: '#ffc862',

      /**
       * Fallback color
       */
      highlight: '#ffc862',

      /**
       * Fallback color
       */
      press: '#ffc862',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#ffc862',

      /**
       * Fallback color
       */
      highlight: '#ffc862',

      /**
       * Fallback color
       */
      press: '#ffc862',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#ffc862',

      /**
       * Fallback color
       */
      highlight: '#ffc862',

      /**
       * Fallback color
       */
      press: '#ffc862',
    },
  },
  text: {
    /**
     * The default text color of the premiumDuoAlternate set.
     */
    base: '#000000',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#283ea3',

    /**
     * Fallback color
     */
    subdued: '#000000',

    /**
     * Fallback color
     */
    negative: '#000000',

    /**
     * Fallback color
     */
    warning: '#000000',

    /**
     * Fallback color
     */
    positive: '#000000',

    /**
     * Fallback color
     */
    announcement: '#000000',
  },
  essential: {
    /**
     * The default essential color of the premiumDuoAlternate set.
     */
    base: '#000000',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#283ea3',

    /**
     * Fallback color
     */
    subdued: '#000000',

    /**
     * Fallback color
     */
    negative: '#000000',

    /**
     * Fallback color
     */
    warning: '#000000',

    /**
     * Fallback color
     */
    positive: '#000000',

    /**
     * Fallback color
     */
    announcement: '#000000',
  },
  decorative: {
    /**
     * The default decorative color of the premiumDuoAlternate set.
     */
    base: '#000000',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#ffb223',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumStudentSet = (exports.premiumStudentSet = {
  background: {
    /**
     * The default background color of the premiumStudent set.
     */
    base: '#af93c4',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#b49ac8',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#885ea7',
    elevated: {
      /**
       * Fallback color
       */
      base: '#af93c4',

      /**
       * Fallback color
       */
      highlight: '#af93c4',

      /**
       * Fallback color
       */
      press: '#af93c4',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#af93c4',

      /**
       * Fallback color
       */
      highlight: '#af93c4',

      /**
       * Fallback color
       */
      press: '#af93c4',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#af93c4',

      /**
       * Fallback color
       */
      highlight: '#af93c4',

      /**
       * Fallback color
       */
      press: '#af93c4',
    },
  },
  text: {
    /**
     * The default text color of the premiumStudent set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  essential: {
    /**
     * The default essential color of the premiumStudent set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  decorative: {
    /**
     * The default decorative color of the premiumStudent set.
     */
    base: '#121212',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#9f7db8',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumStudentAlternateSet = (exports.premiumStudentAlternateSet = {
  background: {
    /**
     * The default background color of the premiumStudentAlternate set.
     */
    base: '#121212',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#1a1a1a',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#474747',
    elevated: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
  },
  text: {
    /**
     * The default text color of the premiumStudentAlternate set.
     */
    base: '#af93c4',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#af93c4',

    /**
     * Fallback color
     */
    negative: '#af93c4',

    /**
     * Fallback color
     */
    warning: '#af93c4',

    /**
     * Fallback color
     */
    positive: '#af93c4',

    /**
     * Fallback color
     */
    announcement: '#af93c4',
  },
  essential: {
    /**
     * The default essential color of the premiumStudentAlternate set.
     */
    base: '#af93c4',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#af93c4',

    /**
     * Fallback color
     */
    negative: '#af93c4',

    /**
     * Fallback color
     */
    warning: '#af93c4',

    /**
     * Fallback color
     */
    positive: '#af93c4',

    /**
     * Fallback color
     */
    announcement: '#af93c4',
  },
  decorative: {
    /**
     * The default decorative color of the premiumStudentAlternate set.
     */
    base: '#af93c4',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#292929',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumFamilySet = (exports.premiumFamilySet = {
  background: {
    /**
     * The default background color of the premiumFamily set.
     */
    base: '#a5bbd1',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#aec2d6',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#6389af',
    elevated: {
      /**
       * Fallback color
       */
      base: '#a5bbd1',

      /**
       * Fallback color
       */
      highlight: '#a5bbd1',

      /**
       * Fallback color
       */
      press: '#a5bbd1',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#a5bbd1',

      /**
       * Fallback color
       */
      highlight: '#a5bbd1',

      /**
       * Fallback color
       */
      press: '#a5bbd1',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#a5bbd1',

      /**
       * Fallback color
       */
      highlight: '#a5bbd1',

      /**
       * Fallback color
       */
      press: '#a5bbd1',
    },
  },
  text: {
    /**
     * The default text color of the premiumFamily set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  essential: {
    /**
     * The default essential color of the premiumFamily set.
     */
    base: '#121212',

    /**
     * Fallback color
     */
    subdued: '#121212',

    /**
     * Fallback color
     */
    brightAccent: '#121212',

    /**
     * Fallback color
     */
    negative: '#121212',

    /**
     * Fallback color
     */
    warning: '#121212',

    /**
     * Fallback color
     */
    positive: '#121212',

    /**
     * Fallback color
     */
    announcement: '#121212',
  },
  decorative: {
    /**
     * The default decorative color of the premiumFamily set.
     */
    base: '#121212',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#88a5c2',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var premiumFamilyAlternateSet = (exports.premiumFamilyAlternateSet = {
  background: {
    /**
     * The default background color of the premiumFamilyAlternate set.
     */
    base: '#121212',

    /**
     * A background color that indicates the hover state of a component, or adds some oomph to a focus state.
     */
    highlight: '#1a1a1a',

    /**
     * A background color that indicates the press state of a component.
     */
    press: '#474747',
    elevated: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#121212',

      /**
       * Fallback color
       */
      highlight: '#121212',

      /**
       * Fallback color
       */
      press: '#121212',
    },
  },
  text: {
    /**
     * The default text color of the premiumFamilyAlternate set.
     */
    base: '#a5bbd1',

    /**
     * A bright text color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#a5bbd1',

    /**
     * Fallback color
     */
    negative: '#a5bbd1',

    /**
     * Fallback color
     */
    warning: '#a5bbd1',

    /**
     * Fallback color
     */
    positive: '#a5bbd1',

    /**
     * Fallback color
     */
    announcement: '#a5bbd1',
  },
  essential: {
    /**
     * The default essential color of the premiumFamilyAlternate set.
     */
    base: '#a5bbd1',

    /**
     * A bright essential color that contrasts with the set’s background colors. Often used to give key interactive elements more prominence.
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#a5bbd1',

    /**
     * Fallback color
     */
    negative: '#a5bbd1',

    /**
     * Fallback color
     */
    warning: '#a5bbd1',

    /**
     * Fallback color
     */
    positive: '#a5bbd1',

    /**
     * Fallback color
     */
    announcement: '#a5bbd1',
  },
  decorative: {
    /**
     * The default decorative color of the premiumFamilyAlternate set.
     */
    base: '#a5bbd1',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#292929',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var aubergineSet = (exports.aubergineSet = {
  background: {
    /**
     * The default background color of the aubergine set.
     */
    base: '#503659',

    /**
     * Fallback color
     */
    highlight: '#503659',

    /**
     * Fallback color
     */
    press: '#503659',
    elevated: {
      /**
       * Fallback color
       */
      base: '#503659',

      /**
       * Fallback color
       */
      highlight: '#503659',

      /**
       * Fallback color
       */
      press: '#503659',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#503659',

      /**
       * Fallback color
       */
      highlight: '#503659',

      /**
       * Fallback color
       */
      press: '#503659',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#503659',

      /**
       * Fallback color
       */
      highlight: '#503659',

      /**
       * Fallback color
       */
      press: '#503659',
    },
  },
  text: {
    /**
     * The default text color of the aubergine set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the aubergine set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the aubergine set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#684674',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var azureSet = (exports.azureSet = {
  background: {
    /**
     * The default background color of the azure set.
     */
    base: '#0d72ed',

    /**
     * Fallback color
     */
    highlight: '#0d72ed',

    /**
     * Fallback color
     */
    press: '#0d72ed',
    elevated: {
      /**
       * Fallback color
       */
      base: '#0d72ed',

      /**
       * Fallback color
       */
      highlight: '#0d72ed',

      /**
       * Fallback color
       */
      press: '#0d72ed',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#0d72ed',

      /**
       * Fallback color
       */
      highlight: '#0d72ed',

      /**
       * Fallback color
       */
      press: '#0d72ed',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#0d72ed',

      /**
       * Fallback color
       */
      highlight: '#0d72ed',

      /**
       * Fallback color
       */
      press: '#0d72ed',
    },
  },
  text: {
    /**
     * The default text color of the azure set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the azure set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the azure set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#2c86f4',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var boleSet = (exports.boleSet = {
  background: {
    /**
     * The default background color of the bole set.
     */
    base: '#b06239',

    /**
     * Fallback color
     */
    highlight: '#b06239',

    /**
     * Fallback color
     */
    press: '#b06239',
    elevated: {
      /**
       * Fallback color
       */
      base: '#b06239',

      /**
       * Fallback color
       */
      highlight: '#b06239',

      /**
       * Fallback color
       */
      press: '#b06239',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#b06239',

      /**
       * Fallback color
       */
      highlight: '#b06239',

      /**
       * Fallback color
       */
      press: '#b06239',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#b06239',

      /**
       * Fallback color
       */
      highlight: '#b06239',

      /**
       * Fallback color
       */
      press: '#b06239',
    },
  },
  text: {
    /**
     * The default text color of the bole set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the bole set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the bole set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#c5754b',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var brightRedSet = (exports.brightRedSet = {
  background: {
    /**
     * The default background color of the brightRed set.
     */
    base: '#e91429',

    /**
     * Fallback color
     */
    highlight: '#e91429',

    /**
     * Fallback color
     */
    press: '#e91429',
    elevated: {
      /**
       * Fallback color
       */
      base: '#e91429',

      /**
       * Fallback color
       */
      highlight: '#e91429',

      /**
       * Fallback color
       */
      press: '#e91429',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#e91429',

      /**
       * Fallback color
       */
      highlight: '#e91429',

      /**
       * Fallback color
       */
      press: '#e91429',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#e91429',

      /**
       * Fallback color
       */
      highlight: '#e91429',

      /**
       * Fallback color
       */
      press: '#e91429',
    },
  },
  text: {
    /**
     * The default text color of the brightRed set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the brightRed set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the brightRed set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#ee3a4c',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var chocolateSet = (exports.chocolateSet = {
  background: {
    /**
     * The default background color of the chocolate set.
     */
    base: '#834f34',

    /**
     * Fallback color
     */
    highlight: '#834f34',

    /**
     * Fallback color
     */
    press: '#834f34',
    elevated: {
      /**
       * Fallback color
       */
      base: '#834f34',

      /**
       * Fallback color
       */
      highlight: '#834f34',

      /**
       * Fallback color
       */
      press: '#834f34',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#834f34',

      /**
       * Fallback color
       */
      highlight: '#834f34',

      /**
       * Fallback color
       */
      press: '#834f34',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#834f34',

      /**
       * Fallback color
       */
      highlight: '#834f34',

      /**
       * Fallback color
       */
      press: '#834f34',
    },
  },
  text: {
    /**
     * The default text color of the chocolate set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the chocolate set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the chocolate set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#9c5e3e',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var citricSet = (exports.citricSet = {
  background: {
    /**
     * The default background color of the citric set.
     */
    base: '#608109',

    /**
     * Fallback color
     */
    highlight: '#608109',

    /**
     * Fallback color
     */
    press: '#608109',
    elevated: {
      /**
       * Fallback color
       */
      base: '#608109',

      /**
       * Fallback color
       */
      highlight: '#608109',

      /**
       * Fallback color
       */
      press: '#608109',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#608109',

      /**
       * Fallback color
       */
      highlight: '#608109',

      /**
       * Fallback color
       */
      press: '#608109',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#608109',

      /**
       * Fallback color
       */
      highlight: '#608109',

      /**
       * Fallback color
       */
      press: '#608109',
    },
  },
  text: {
    /**
     * The default text color of the citric set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the citric set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the citric set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#6f950a',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var forestSet = (exports.forestSet = {
  background: {
    /**
     * The default background color of the forest set.
     */
    base: '#056952',

    /**
     * Fallback color
     */
    highlight: '#056952',

    /**
     * Fallback color
     */
    press: '#056952',
    elevated: {
      /**
       * Fallback color
       */
      base: '#056952',

      /**
       * Fallback color
       */
      highlight: '#056952',

      /**
       * Fallback color
       */
      press: '#056952',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#056952',

      /**
       * Fallback color
       */
      highlight: '#056952',

      /**
       * Fallback color
       */
      press: '#056952',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#056952',

      /**
       * Fallback color
       */
      highlight: '#056952',

      /**
       * Fallback color
       */
      press: '#056952',
    },
  },
  text: {
    /**
     * The default text color of the forest set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the forest set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the forest set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#067d62',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var fuchsiaSet = (exports.fuchsiaSet = {
  background: {
    /**
     * The default background color of the fuchsia set.
     */
    base: '#e1118c',

    /**
     * Fallback color
     */
    highlight: '#e1118c',

    /**
     * Fallback color
     */
    press: '#e1118c',
    elevated: {
      /**
       * Fallback color
       */
      base: '#e1118c',

      /**
       * Fallback color
       */
      highlight: '#e1118c',

      /**
       * Fallback color
       */
      press: '#e1118c',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#e1118c',

      /**
       * Fallback color
       */
      highlight: '#e1118c',

      /**
       * Fallback color
       */
      press: '#e1118c',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#e1118c',

      /**
       * Fallback color
       */
      highlight: '#e1118c',

      /**
       * Fallback color
       */
      press: '#e1118c',
    },
  },
  text: {
    /**
     * The default text color of the fuchsia set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the fuchsia set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the fuchsia set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#f03ca7',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var goldSet = (exports.goldSet = {
  background: {
    /**
     * The default background color of the gold set.
     */
    base: '#bc5900',

    /**
     * Fallback color
     */
    highlight: '#bc5900',

    /**
     * Fallback color
     */
    press: '#bc5900',
    elevated: {
      /**
       * Fallback color
       */
      base: '#bc5900',

      /**
       * Fallback color
       */
      highlight: '#bc5900',

      /**
       * Fallback color
       */
      press: '#bc5900',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#bc5900',

      /**
       * Fallback color
       */
      highlight: '#bc5900',

      /**
       * Fallback color
       */
      press: '#bc5900',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#bc5900',

      /**
       * Fallback color
       */
      highlight: '#bc5900',

      /**
       * Fallback color
       */
      press: '#bc5900',
    },
  },
  text: {
    /**
     * The default text color of the gold set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the gold set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the gold set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#d86600',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var graySet = (exports.graySet = {
  background: {
    /**
     * The default background color of the gray set.
     */
    base: '#777777',

    /**
     * Fallback color
     */
    highlight: '#777777',

    /**
     * Fallback color
     */
    press: '#777777',
    elevated: {
      /**
       * Fallback color
       */
      base: '#777777',

      /**
       * Fallback color
       */
      highlight: '#777777',

      /**
       * Fallback color
       */
      press: '#777777',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#777777',

      /**
       * Fallback color
       */
      highlight: '#777777',

      /**
       * Fallback color
       */
      press: '#777777',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#777777',

      /**
       * Fallback color
       */
      highlight: '#777777',

      /**
       * Fallback color
       */
      press: '#777777',
    },
  },
  text: {
    /**
     * The default text color of the gray set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the gray set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the gray set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#898989',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var lavenderSet = (exports.lavenderSet = {
  background: {
    /**
     * The default background color of the lavender set.
     */
    base: '#8e66ac',

    /**
     * Fallback color
     */
    highlight: '#8e66ac',

    /**
     * Fallback color
     */
    press: '#8e66ac',
    elevated: {
      /**
       * Fallback color
       */
      base: '#8e66ac',

      /**
       * Fallback color
       */
      highlight: '#8e66ac',

      /**
       * Fallback color
       */
      press: '#8e66ac',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#8e66ac',

      /**
       * Fallback color
       */
      highlight: '#8e66ac',

      /**
       * Fallback color
       */
      press: '#8e66ac',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#8e66ac',

      /**
       * Fallback color
       */
      highlight: '#8e66ac',

      /**
       * Fallback color
       */
      press: '#8e66ac',
    },
  },
  text: {
    /**
     * The default text color of the lavender set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the lavender set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the lavender set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#9d7bb7',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var maroonSet = (exports.maroonSet = {
  background: {
    /**
     * The default background color of the maroon set.
     */
    base: '#8a202b',

    /**
     * Fallback color
     */
    highlight: '#8a202b',

    /**
     * Fallback color
     */
    press: '#8a202b',
    elevated: {
      /**
       * Fallback color
       */
      base: '#8a202b',

      /**
       * Fallback color
       */
      highlight: '#8a202b',

      /**
       * Fallback color
       */
      press: '#8a202b',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#8a202b',

      /**
       * Fallback color
       */
      highlight: '#8a202b',

      /**
       * Fallback color
       */
      press: '#8a202b',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#8a202b',

      /**
       * Fallback color
       */
      highlight: '#8a202b',

      /**
       * Fallback color
       */
      press: '#8a202b',
    },
  },
  text: {
    /**
     * The default text color of the maroon set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the maroon set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the maroon set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#ac2835',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var midnightSet = (exports.midnightSet = {
  background: {
    /**
     * The default background color of the midnight set.
     */
    base: '#202f72',

    /**
     * Fallback color
     */
    highlight: '#202f72',

    /**
     * Fallback color
     */
    press: '#202f72',
    elevated: {
      /**
       * Fallback color
       */
      base: '#202f72',

      /**
       * Fallback color
       */
      highlight: '#202f72',

      /**
       * Fallback color
       */
      press: '#202f72',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#202f72',

      /**
       * Fallback color
       */
      highlight: '#202f72',

      /**
       * Fallback color
       */
      press: '#202f72',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#202f72',

      /**
       * Fallback color
       */
      highlight: '#202f72',

      /**
       * Fallback color
       */
      press: '#202f72',
    },
  },
  text: {
    /**
     * The default text color of the midnight set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the midnight set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the midnight set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#2b3f99',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var neonGreenSet = (exports.neonGreenSet = {
  background: {
    /**
     * The default background color of the neonGreen set.
     */
    base: '#148a08',

    /**
     * Fallback color
     */
    highlight: '#148a08',

    /**
     * Fallback color
     */
    press: '#148a08',
    elevated: {
      /**
       * Fallback color
       */
      base: '#148a08',

      /**
       * Fallback color
       */
      highlight: '#148a08',

      /**
       * Fallback color
       */
      press: '#148a08',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#148a08',

      /**
       * Fallback color
       */
      highlight: '#148a08',

      /**
       * Fallback color
       */
      press: '#148a08',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#148a08',

      /**
       * Fallback color
       */
      highlight: '#148a08',

      /**
       * Fallback color
       */
      press: '#148a08',
    },
  },
  text: {
    /**
     * The default text color of the neonGreen set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the neonGreen set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the neonGreen set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#179e09',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var orangeSet = (exports.orangeSet = {
  background: {
    /**
     * The default background color of the orange set.
     */
    base: '#d84000',

    /**
     * Fallback color
     */
    highlight: '#d84000',

    /**
     * Fallback color
     */
    press: '#d84000',
    elevated: {
      /**
       * Fallback color
       */
      base: '#d84000',

      /**
       * Fallback color
       */
      highlight: '#d84000',

      /**
       * Fallback color
       */
      press: '#d84000',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#d84000',

      /**
       * Fallback color
       */
      highlight: '#d84000',

      /**
       * Fallback color
       */
      press: '#d84000',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#d84000',

      /**
       * Fallback color
       */
      highlight: '#d84000',

      /**
       * Fallback color
       */
      press: '#d84000',
    },
  },
  text: {
    /**
     * The default text color of the orange set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the orange set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the orange set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#f84a00',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var royalBlueSet = (exports.royalBlueSet = {
  background: {
    /**
     * The default background color of the royalBlue set.
     */
    base: '#283ea3',

    /**
     * Fallback color
     */
    highlight: '#283ea3',

    /**
     * Fallback color
     */
    press: '#283ea3',
    elevated: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#283ea3',

      /**
       * Fallback color
       */
      highlight: '#283ea3',

      /**
       * Fallback color
       */
      press: '#283ea3',
    },
  },
  text: {
    /**
     * The default text color of the royalBlue set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the royalBlue set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the royalBlue set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#324dcb',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var salmonSet = (exports.salmonSet = {
  background: {
    /**
     * The default background color of the salmon set.
     */
    base: '#e41d63',

    /**
     * Fallback color
     */
    highlight: '#e41d63',

    /**
     * Fallback color
     */
    press: '#e41d63',
    elevated: {
      /**
       * Fallback color
       */
      base: '#e41d63',

      /**
       * Fallback color
       */
      highlight: '#e41d63',

      /**
       * Fallback color
       */
      press: '#e41d63',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#e41d63',

      /**
       * Fallback color
       */
      highlight: '#e41d63',

      /**
       * Fallback color
       */
      press: '#e41d63',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#e41d63',

      /**
       * Fallback color
       */
      highlight: '#e41d63',

      /**
       * Fallback color
       */
      press: '#e41d63',
    },
  },
  text: {
    /**
     * The default text color of the salmon set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the salmon set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the salmon set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#e94780',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var spearmintSet = (exports.spearmintSet = {
  background: {
    /**
     * The default background color of the spearmint set.
     */
    base: '#438270',

    /**
     * Fallback color
     */
    highlight: '#438270',

    /**
     * Fallback color
     */
    press: '#438270',
    elevated: {
      /**
       * Fallback color
       */
      base: '#438270',

      /**
       * Fallback color
       */
      highlight: '#438270',

      /**
       * Fallback color
       */
      press: '#438270',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#438270',

      /**
       * Fallback color
       */
      highlight: '#438270',

      /**
       * Fallback color
       */
      press: '#438270',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#438270',

      /**
       * Fallback color
       */
      highlight: '#438270',

      /**
       * Fallback color
       */
      press: '#438270',
    },
  },
  text: {
    /**
     * The default text color of the spearmint set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the spearmint set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the spearmint set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#4d9681',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var stormSet = (exports.stormSet = {
  background: {
    /**
     * The default background color of the storm set.
     */
    base: '#537aa1',

    /**
     * Fallback color
     */
    highlight: '#537aa1',

    /**
     * Fallback color
     */
    press: '#537aa1',
    elevated: {
      /**
       * Fallback color
       */
      base: '#537aa1',

      /**
       * Fallback color
       */
      highlight: '#537aa1',

      /**
       * Fallback color
       */
      press: '#537aa1',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#537aa1',

      /**
       * Fallback color
       */
      highlight: '#537aa1',

      /**
       * Fallback color
       */
      press: '#537aa1',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#537aa1',

      /**
       * Fallback color
       */
      highlight: '#537aa1',

      /**
       * Fallback color
       */
      press: '#537aa1',
    },
  },
  text: {
    /**
     * The default text color of the storm set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the storm set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the storm set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#678cb2',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var tanSet = (exports.tanSet = {
  background: {
    /**
     * The default background color of the tan set.
     */
    base: '#a56753',

    /**
     * Fallback color
     */
    highlight: '#a56753',

    /**
     * Fallback color
     */
    press: '#a56753',
    elevated: {
      /**
       * Fallback color
       */
      base: '#a56753',

      /**
       * Fallback color
       */
      highlight: '#a56753',

      /**
       * Fallback color
       */
      press: '#a56753',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#a56753',

      /**
       * Fallback color
       */
      highlight: '#a56753',

      /**
       * Fallback color
       */
      press: '#a56753',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#a56753',

      /**
       * Fallback color
       */
      highlight: '#a56753',

      /**
       * Fallback color
       */
      press: '#a56753',
    },
  },
  text: {
    /**
     * The default text color of the tan set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the tan set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the tan set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#b37b69',
  },
});
/**
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */

var violetSet = (exports.violetSet = {
  background: {
    /**
     * The default background color of the violet set.
     */
    base: '#b02897',

    /**
     * Fallback color
     */
    highlight: '#b02897',

    /**
     * Fallback color
     */
    press: '#b02897',
    elevated: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
    tinted: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
    unsafeForSmallText: {
      /**
       * Fallback color
       */
      base: '#b02897',

      /**
       * Fallback color
       */
      highlight: '#b02897',

      /**
       * Fallback color
       */
      press: '#b02897',
    },
  },
  text: {
    /**
     * The default text color of the violet set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  essential: {
    /**
     * The default essential color of the violet set.
     */
    base: '#ffffff',

    /**
     * Fallback color
     */
    subdued: '#ffffff',

    /**
     * Fallback color
     */
    brightAccent: '#ffffff',

    /**
     * Fallback color
     */
    negative: '#ffffff',

    /**
     * Fallback color
     */
    warning: '#ffffff',

    /**
     * Fallback color
     */
    positive: '#ffffff',

    /**
     * Fallback color
     */
    announcement: '#ffffff',
  },
  decorative: {
    /**
     * The default decorative color of the violet set.
     */
    base: '#ffffff',

    /**
     * A subdued variant of the base decorative color.
     */
    subdued: '#cd2fb0',
  },
});
var campaign = (exports.campaign = {
  spotifyBrandSet: spotifyBrandSet,
  spotifyBrandAlternateSet: spotifyBrandAlternateSet,
  spotifyBrand2Set: spotifyBrand2Set,
  spotifyBrand2AlternateSet: spotifyBrand2AlternateSet,
  spotifyBrand3Set: spotifyBrand3Set,
  spotifyBrand3AlternateSet: spotifyBrand3AlternateSet,
  premiumSet: premiumSet,
  premiumAlternateSet: premiumAlternateSet,
  premiumDuoSet: premiumDuoSet,
  premiumDuoAlternateSet: premiumDuoAlternateSet,
  premiumStudentSet: premiumStudentSet,
  premiumStudentAlternateSet: premiumStudentAlternateSet,
  premiumFamilySet: premiumFamilySet,
  premiumFamilyAlternateSet: premiumFamilyAlternateSet,
});
var category = (exports.category = {
  aubergineSet: aubergineSet,
  azureSet: azureSet,
  boleSet: boleSet,
  brightRedSet: brightRedSet,
  chocolateSet: chocolateSet,
  citricSet: citricSet,
  forestSet: forestSet,
  fuchsiaSet: fuchsiaSet,
  goldSet: goldSet,
  graySet: graySet,
  lavenderSet: lavenderSet,
  maroonSet: maroonSet,
  midnightSet: midnightSet,
  neonGreenSet: neonGreenSet,
  orangeSet: orangeSet,
  royalBlueSet: royalBlueSet,
  salmonSet: salmonSet,
  spearmintSet: spearmintSet,
  stormSet: stormSet,
  tanSet: tanSet,
  violetSet: violetSet,
});
